import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Grid,
  CircularProgress,
  InputAdornment,
  Typography,
  useTheme,
  useMediaQuery,
  Stack,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import useAlert from "../../../../hooks/useAlert";
import { validateCompany } from "../../../../utils/validation";
import {
  addCompany,
  CompanyUpdate,
  GetCompanyAction,
} from "../../../../redux/actions/companyAction";
import PropTypes from "prop-types";

const CompanySettings = ({ setcompanyId }) => {
  const authUserId = useSelector((state) => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const dispatch = useDispatch();
  const { showSuccessCompany, showErrorAlertCompany } = useAlert();
  const { loading, error } = useSelector((state) => state.auth);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const handleInputChangeStore = (e) => {
    const { name, value } = e.target;
    setFormValuesStore({ ...formValuesCompany, [name]: value });
  };
  const [formErrors, setFormErrors] = useState({});
  const [formValuesCompany, setFormValuesStore] = useState({
    name: "",
    identifier: "",
  });

  const [dataExists, setFormValuesDataExists] = useState(false);
  const companyAdd = async (e) => {
    e.preventDefault();
    const errors = validateCompany(formValuesCompany);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      formValuesCompany.userId = authUserId;
      try {
        await dispatch(addCompany(formValuesCompany, token));
        showSuccessCompany();
      } catch {
        showErrorAlertCompany();
      }
    }
  };
  const companyUpdate = async (e) => {
    e.preventDefault();
    const errors = validateCompany(formValuesCompany);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      formValuesCompany.userId = authUserId;
      try {
        await dispatch(CompanyUpdate(formValuesCompany, token));
        showSuccessCompany();
      } catch {
        showErrorAlertCompany();
      }
    }
  };
  //mağza bilgilerini getir
  const getCompany = async () => {
    try {
      const id = authUserId;
      const response = await dispatch(GetCompanyAction(id, token));
      setFormValuesStore(response.data[0]);
      setcompanyId(response.data[0].id);
      if (response.data.length > 0) {
        setFormValuesDataExists(true);
      }
      return response;
    } catch (error) {
      console.error("Error fetching store:", error);
    }
  };
  useEffect(() => {
    getCompany();
  }, []);
  return (
    <Box
      component="form"
      onSubmit={dataExists ? companyUpdate : companyAdd}
      sx={{
        mt: { xs: 2, sm: 3 },
        width: "100%",
      }}
    >
      <Grid container spacing={{ xs: 1.5, sm: 2 }}>
        <Grid item xs={12}>
          <TextField
            size={isMobile ? "small" : "medium"}
            name="name"
            fullWidth
            label="Şirket İsmi"
            value={formValuesCompany?.name}
            onChange={handleInputChangeStore}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
            error={!!formErrors.name}
            helperText={formErrors.name}
            sx={{
              "& .MuiInputLabel-root": {
                fontSize: { xs: "0.875rem", sm: "1rem" },
              },
              "& .MuiInputBase-input": {
                fontSize: { xs: "0.875rem", sm: "1rem" },
              },
              "& .MuiFormHelperText-root": {
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            size={isMobile ? "small" : "medium"}
            name="identifier"
            fullWidth
            label="Tc /Vergi No"
            value={formValuesCompany?.identifier}
            onChange={handleInputChangeStore}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start"></InputAdornment>
              ),
            }}
            error={!!formErrors.identifier}
            helperText={formErrors.identifier}
            sx={{
              "& .MuiInputLabel-root": {
                fontSize: { xs: "0.875rem", sm: "1rem" },
              },
              "& .MuiInputBase-input": {
                fontSize: { xs: "0.875rem", sm: "1rem" },
              },
              "& .MuiFormHelperText-root": {
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
              },
            }}
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          mt: { xs: 2, sm: 4 },
          mb: { xs: 1, sm: 2 },
        }}
      >
        <Button
          type="submit"
          variant="contained"
          sx={{
            borderRadius: 1,
            backgroundColor: "#1F1B45",
            color: "#FFFFFF",
            textTransform: "none",
            fontWeight: 500,
            fontSize: { xs: "0.813rem", sm: "0.875rem" },
            padding: { xs: "8px 16px", sm: "10px 20px" },
            display: "flex",
            alignItems: "center",
            gap: 1,
            minWidth: { xs: "120px", sm: "140px" },
            "&:hover": {
              backgroundColor: "#2C285A",
            },
            "& .MuiCircularProgress-root": {
              width: { xs: "20px !important", sm: "24px !important" },
              height: { xs: "20px !important", sm: "24px !important" },
            },
          }}
          disabled={loading}
        >
          {loading ? (
            <CircularProgress
              size={isMobile ? 20 : 24}
              sx={{ color: "inherit" }}
            />
          ) : (
            "Kaydet"
          )}
        </Button>
      </Box>

      {error && (
        <Typography
          color="error"
          sx={{
            fontSize: { xs: "0.875rem", sm: "1rem" },
            mt: 1,
            textAlign: "center",
          }}
        >
          {error.message}
        </Typography>
      )}
    </Box>
  );
};

CompanySettings.propTypes = {
  setcompanyId: PropTypes.func.isRequired,
};

export default CompanySettings;
